import React from "react"
import styled from "styled-components"

const Container = styled.div``

const Category = styled.p`
	color: #747474;
	font-family: Mallory;
	font-size: 12px;
	font-weight: 900;
	letter-spacing: 1px;
	line-height: 14px;
	margin: 24px 0 0 0;
	text-transform: uppercase;
`

const Title = styled.h5`
	color: #070808;
	font-family: Mallory-Book;
	font-size: 20px;
	font-weight: 300;
	letter-spacing: 1.43px;
	line-height: 24px;
	margin: 0;
	margin-bottom: 37px;
	text-transform: capitalize;
	@media (max-width: 767px) {
		margin-bottom: 13px;
	}
`

const FirstImage = styled.img`
	height: 228px;
	width: 604px;
	object-fit: cover;
	@media (max-width: 767px) {
		width: 100%;
		height: 228px;
	}
`

const Images = styled.img`
	height: 228px;
	width: 100%;
	object-fit: cover;
	@media (max-width: 767px) {
		height: 228px;
	}
`

const FirstContainer = styled.div`
	flex: 0 1 46%;
	margin: 0 16px;
	background: #ffffff;
	padding-bottom: 36px;
`

const NextContainer = styled.div`
	flex: 0 1 22%;
	margin: 0 16px;
	background: #ffffff;
	padding-bottom: 36px;
`

const Link = styled.a`
	color: #777777;
	font-family: Mallory;
	font-size: 14px;
	font-weight: 900;
	letter-spacing: 0;
	line-height: 20px;
`

const TextBlock = styled.div`
	margin: 0 24px;
`

export const RelatedArticles = ({ data, value }) => {
	const title = data.results[0].data.title[0]?.text
	const category = data.results[0].data.categories[0]?.category.slug
	const image = data.results[0].data.featured_image?.url
	const link = data.results[0]?.uid

	return (
		<>
			<RelatedReturn
				category={category}
				title={title}
				img={image}
				value={value}
				link={link}
			></RelatedReturn>
		</>
	)
}

function RelatedReturn(props) {
	if (props.value == 0) {
		return (
			<>
				<FirstContainer>
					<FirstImage src={props.img} />
					<TextBlock>
						<Category>{props.category}</Category>
						<Title>{props.title}</Title>
						<Link href={props.link}>Read More</Link>
					</TextBlock>
				</FirstContainer>
			</>
		)
	} else if (props.value == 1) {
		return (
			<>
				<NextContainer>
					<Images src={props.img} />
					<TextBlock>
						<Category>{props.category}</Category>
						<Title>{props.title}</Title>
						<Link href={props.link}>Read More</Link>
					</TextBlock>
				</NextContainer>
			</>
		)
	} else if (props.value == 2) {
		return (
			<>
				<NextContainer>
					<Images src={props.img} />
					<TextBlock>
						<Category>{props.category}</Category>
						<Title>{props.title}</Title>
						<Link href={props.link}>Read More</Link>
					</TextBlock>
				</NextContainer>
			</>
		)
	}
}
